import { useQuery } from '@tanstack/react-query';
import { WithQueryStatus } from '../../../types/withQueryStatus';
import { IContractTemplate } from '@clickersphere/core/entities/IContractTemplate';
import ContractTemplateService from '@clickersphere/core/services/ContractTemplateService';
import { useBuildQueryKey } from '../useBuildQueryKey';
import { useUserMe } from '../user/useUserMe';

export const CONTRACT_TEMPLATES_QUERY_KEY = 'contract-templates';

export type ContractTemplateQueryData = WithQueryStatus<IContractTemplate>;

interface IUseContractTemplatesOptions {
  enabled?: boolean;
}

export function useContractTemplates(options?: IUseContractTemplatesOptions) {
  const { selectedTenantId } = useUserMe();
  const { buildQueryKey } = useBuildQueryKey();

  const {
    data: contractTemplates,
    isSuccess: isContractTemplatesSuccess,
    isFetching: isContractTemplatesFetching,
    isLoading: isContractTemplatesLoading,
  } = useQuery({
    staleTime: 1000 * 60 * 5,
    enabled: !!selectedTenantId && (options?.enabled ?? true),
    queryKey: buildQueryKey(CONTRACT_TEMPLATES_QUERY_KEY),
    queryFn: async () => {
      const result = await ContractTemplateService.getAll();
      return result as ContractTemplateQueryData[];
    },
    select: (data) => [...data].sort((a, b) => a.name.localeCompare(b.name)),
  });

  return {
    contractTemplates: contractTemplates ?? [],
    isContractTemplatesSuccess,
    isContractTemplatesFetching,
    isContractTemplatesLoading,
  };
}
